<template>
  <main class="flex">
    <section class="login-section flex s-a-center">
      <div class="login-illustration">
        <illu></illu>
      </div>
      <div class="login-box box">
        <h1>Spoti-Suggest</h1>
        <p class="body-copy">
          Searching and discovering new music is a process that is enjoyable but oftentimes very time-consuming.</p>
        <p>
          So whenever you're lacking time but are in need for some new tunes there's <i>Spoti-Suggest!</i> This project is <strong>directly powered
          by the Spotify-API</strong> which enables you to connect with your user-profile and generate music suggestions at the click of a button!
        </p>
        <p class="body-copy">Make a selection out of your favorite artists or add specific ones via search to generate music you'll want to listen to.</p>
        <a class="btn btn-primary" :href="`https://accounts.spotify.com/authorize?client_id=${clientId}&state=${authState}&response_type=token&redirect_uri=${redirectUri}&scope=user-read-recently-played`">Authorize now</a>
      </div>
    </section>
    
  </main>
</template>

<script>
import illu from '../components/login/LoginIllu';
export default {
  name: 'Login',
  components: {
    illu
  },
  data: () => {
    return {
        clientId: 'a8c354057fed434dbf266cb7d49f2149',
        redirectUri: 'https://pidoubleju.github.io/spoti-suggest/#/login?',
        authState: '',
    }
  },
  methods: {
    createAuthState() {
      return Math.random().toString(36).substr(2);
    }
  },
  mounted() {
    this.authState = this.createAuthState();
  }
}
</script>

<style scoped>
  main {
    width: 100%;
  }
  .login-section {
    width: 100%;
  }
  .login-illustration {
    flex: 3;
  }
  .login-box {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    padding: 3rem 2rem;
    margin-right: 2rem;
  }
</style>